export let moveItemFailedNotification = "cFqdk";
export default {moveItemFailedNotification};